import React, { use, useEffect } from "react";
import {
  StyledIconButton,
} from "../../../components/StyledComponents/Buttons/AuradineButtons.js";
import { StyledDialog } from "../../../components/StyledComponents/Dialog/Dialog.js";
import {
  BodyMedium,
  H6HeadlineSmall,
} from "../../../components/StyledComponents/Typography/Typography.tsx";
import {
  DialogContent,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Box } from "@mui/material";
import DataGrid from "../../../components/DataGrid/DataGrid.tsx";
import { StyledDataGrid } from "../../../components/StyledComponents/DataGrid/StyledDataGrid.tsx";
import { useTheme } from "../../../ThemeContext/ThemeContext.js";

export default function PriceConfigSitesDialog( props ) {
  const { openPriceDialog, setOpenPriceDialog, setArrayMessage, arrayMessage } = props
  const { colors } = useTheme();

  const columns = [
    {
      field: "site",
      headerName: "Site",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "message",
      headerName: "Status",
      flex: 1,
      minWidth: 100,
    },
  ];

const priceDialogRows = Array.isArray(arrayMessage) && arrayMessage.length > 0
? arrayMessage.reduce((acc, val, index) => {
    if (index % 2 === 0 && typeof arrayMessage[index + 1] !== 'undefined') {
      const colonIndex = val.indexOf(':');
      const siteName = colonIndex !== -1 ? val.slice(colonIndex + 1).trim() : null;
      acc.push({
        id: acc.length + 1,
        site: siteName,
        message: arrayMessage[index + 1]
      });
    }
    return acc;
  }, [])
: [];

const dataGridProps = {
  rows: priceDialogRows || [],
  columns: columns,
  autoHeight: true,
  hideFooter: true,
  getRowId: (row) => row.id,
  getRowHeight: () => "auto",
};

  return(
    <StyledDialog
    colors={colors}
    maxWidth={"xl"}
    fullWidth
    open={openPriceDialog}
    hideBackdrop
    onClose={(event, reason) => {
      if (reason === "backdropClick") {
        setOpenPriceDialog(false);
      }
    }}
    >
      <DialogContent sx={{ padding: 0 }}>
        <>
        <Box
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"space-between"}
        flexGrow={1}
        padding={"1.5rem 0"}
        >
        <Box
          display={"flex"}
          flexDirection={"column"}
          gap={2}
        >
          <H6HeadlineSmall>{"Status of Sites(s) Association with Pricing Profile"}</H6HeadlineSmall>

          <BodyMedium>
            Use this window to view the status of recent price configurations by site.
          </BodyMedium>
        </Box>

        <StyledIconButton 
          colors={colors}
          onClick={() => {
            setOpenPriceDialog(false);
            setArrayMessage([])
          }}
        >
          <CloseIcon />
        </StyledIconButton>
        </Box>

        <Box display={"flex"} flexGrow={1}>
          {arrayMessage &&
            Array.isArray(arrayMessage) &&
            arrayMessage.length > 0 &&
            columns.length > 0 && (
              <>
                {" "}
                <StyledDataGrid
                  colors={colors}
                  {...dataGridProps }
                  height={"auto"}
                  sx={{
    "& .MuiDataGrid-cell": {
        color: colors?.text?.label,
        fontWeight: 400,
        fontSize: "1rem",
        fontFamily: "Roboto",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        border: "none",
        py: "0.5rem",
        minHeight: "3rem !important",
        lineHeight: "1.5rem", 
        padding: "0.25rem 1.5rem 0.25rem 1rem", 
        "&:focus, &:focus-within": {
          outline: "none",
        },
      },
    "& .MuiDataGrid-cellContent": {
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      display: 'flex',
      alignItems: 'flex-start',
    },
  }}
                />
              </>
            )}
        </Box>
      </>
      </DialogContent>
  </StyledDialog>
  )
}